import React, { Component } from 'react';
import swal from 'sweetalert';
import endPoint from '../../config';
import axios from '../../httpServices/httpService';
import valid from '../../utill/validation';
import joi from 'joi';
import api from '../../config.json'
import Loading from '../../utill/LoadingComponent';



class Method extends Component {
  state = {
    method: {},
    oldObj: {},
    errors: {},
    querySuccess: false,
  }
  schema = {
    Name: joi.string().required().label('Method Name')
  }

  componentDidMount() {
    this.props.Heading('Inspection Type Master')

    const { location } = this.props.history;
    if (location.state && location.state.action === 'add') {
      this.setState({ method: {} })
    }
    if (location.state && location.state.action === 'update') {
      this.setState({ method: location.state.data, oldObj: location.state.data });
    }
  }

  handleOnChange = (e) => {
    const { method, errors } = { ...this.state };

    const errorMessage = valid.validateProperty(e.currentTarget, this.schema);
    if (errorMessage) errors[e.currentTarget.name] = errorMessage;
    else delete errors[e.currentTarget.name];

    method[e.currentTarget.name] = e.currentTarget.value;
    this.setState({ method, errors: errors || {} });


  }
  handleSubmit = (data) => {
    const { location } = this.props.history;
    // consol(this.props.equipmentTypeList)

    if (location.state && location.state.action === 'add') {
      const errors = valid.validate(data, this.schema);
      this.setState({ errors: errors || {} });
      if (errors) return;

      this.setState({ querySuccess: true });
      axios.post(api.api + 'method', data)
        .then((result) => {
          if (result.status === 200) {
            this.setState({ querySuccess: false });
            this.props.history.push('/setting/method/list')
            swal('Save Data Successfully');
          }
          else {
            this.setState({ querySuccess: false });
            swal(`Data Not Saved`);
          }
        })
        .catch((err) => {
          this.setState({ querySuccess: false });
          swal(`${err.response.data.message}`);
        })

    }
    if (location.state && location.state.action === 'update') {
      this.setState({ querySuccess: true });
      axios.patch(api.api + 'method/' + data._id, data)
        .then((result) => {
          const { n, nModified, ok } = result.data;
          if (ok == 1 && n == 1 && nModified == 1) {
            this.setState({ querySuccess: false });
            this.props.history.push('/setting/method/list')
            swal('Updated Data Successfully');
          }
          else {
            this.setState({ querySuccess: false });
            swal(`${result.data}`);
          }
        })
        .catch((err) => {
          this.setState({ querySuccess: false });
          swal(`${err.response.data.message}`);
        })

    }




  }


  render() {
    return (
      <React.Fragment>
        {this.state.querySuccess ? <Loading /> : ''}


        <div className=" border">
          <div className="row justify-content-center">
            <div className="col-sm-4 ">
              <div className="form-group text-center">
                <label>Method Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="method name"
                  name="Name"
                  onChange={this.handleOnChange}
                  defaultValue={this.state.method.Name}
                />


                {this.state.errors.Name && <div className="alert small alert-danger">{this.state.errors['Name']}</div>}

              </div>


            </div>



          </div>
          <div className="text-center">
            <button
              className="btn btn-primary"
              onClick={() => {
                this.handleSubmit(this.state.method);
              }}
            >
              Submit
            </button>
          </div>

          <div className="text-center" style={{ marginTop: 10 }}>
            <button
              className="btn btn-primary"
              onClick={() => {
                this.props.history.push('/setting/method/list')
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Method;